var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.234 11a.89.89 0 0 1 .891-.89h13.75a.89.89 0 0 1 0 1.78H9.125a.89.89 0 0 1-.89-.89Zm4.641 2.234h10a.89.89 0 0 1 0 1.782h-10a.89.89 0 0 1 0-1.782Zm-3.75 3.125h13.75a.89.89 0 0 1 0 1.782H9.125a.89.89 0 1 1 0-1.782Zm3.75 3.125h10a.89.89 0 0 1 0 1.782h-10a.89.89 0 0 1 0-1.782Z"
  })));
};
export default SvgRight;